import { setUserLocation } from '../ecp-locator.cache';
import { EcpMapUserLocation } from '../../../models';

const setEcpUserLocationToCache = (location: EcpMapUserLocation) => {
  setUserLocation(location);
};

export const useEcpUserLocation = () => ({
  setEcpUserLocationToCache,
});
